import { Grid } from "@mui/material";
import DeviceEvents from "components/Charts/DeviceEvents";
import PropTypes from "prop-types";

function EventsTab({ uuid, deviceLayout }) {
    return <DeviceEvents uuid={uuid} height={deviceLayout == "mobile" ? "calc(100svh - 17.12rem - 16px)" : "calc(100svh - 18.37rem - 16px)"} />; // calc(100svh - 19.6rem - 16px)
}

EventsTab.propTypes = {
    uuid: PropTypes.string,
    deviceLayout: PropTypes.string,
}

export default EventsTab;